import { useRef, useState } from 'react';
import '../css/message_input.css'
import TextareaAutosize from 'react-textarea-autosize';
import sendMessageImage from '../img/send_message.png'
import userImage from '../img/user_image.png'
import AnsweredMessage from './AnsweredMessage';

function MessageInput({setMessages, userId, userName, userImage, chatWs, answeredMessage, setAnsweredMessage}) {
    const [text, setText] = useState('')
    const textAreaRef = useRef(null);
    
    const sendMessage = () => {
        if (text !== '') {
            const formattedWsMessage = {
                user_id: userId,
                text: text,
                is_answered: !!answeredMessage,
                answered_message_id: answeredMessage?.id
            }
            const formattedMessageToList = {
                id: 11111,
                text: text,
                user: {
                    id: userId,
                    name: userName,
                    image: userImage?.image
                },
                is_answered: !!answeredMessage,
                answered_message: answeredMessage
            }
            setText('');
            setMessages(prevMessages => [formattedMessageToList, ...prevMessages]);
            setAnsweredMessage(null);
            chatWs.send(JSON.stringify(formattedWsMessage));
        }
    };

    return <div className='message-input-section'>
        {answeredMessage && <AnsweredMessage answeredMessage={answeredMessage} setAnsweredMessage={setAnsweredMessage}/>}
        <div className='message-input-correct-section'>
        <TextareaAutosize className="message-input" ref={textAreaRef} placeholder='Напишите ваше сообщение...' value={text} onChange={(event) => setText(event.target.value)} maxRows={3}/>
            {text !== '' && 
                <div className='send-message-image-container' onClick={() => sendMessage()}>
                    <img className='send-message-image' alt='error' src={sendMessageImage}/>
                </div>
            }   
        </div>
    </div>
} 
export default MessageInput;